import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem} from "@blueprintjs/core";
import { List, Map } from "immutable";
import numeral from "numeral";
import moment from 'moment';
import Auth from '../../../lib/auth';

// Components
import VirtualizedTable from "../../../components/common/virtualized-table";
import Select from "../../../components/common/virtualized-select";
import Loading from '../../../components/common/Loading';

// Actions
import { getYears, cleanYears } from '../../../actions/years';
import { getSalesInvoices, changeSalesInvoiceStatus, cleanSalesInvoices } from "../../../actions/sales-invoices";

// Numeral configuration
import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

const queryOptions = {
    projection: 'invoice_code document_date expiration_date customer statistics.subtotal statistics.vat statistics.total status retention include_retention',
    populateRefs: [{
        field: 'customer',
        projection: 'basic_info.name'
    }],
    calculateStatistics: 'sales-invoices',
    deleteVirtuals: true
};

class SalesInvoicesPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            salesInvoiceFilters: '',
            selectedYear: Auth.getSelectedYear(),
            salesInvoicesIsFetching: false
        };
    }
    componentDidMount() {
        this.props.getYears();
        this.updateQueryOptions(this.state.selectedYear);
        this.props.getSalesInvoices(queryOptions);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.selectedYear !== prevState.selectedYear) {
            this.updateQueryOptions(this.state.selectedYear);
            this.props.getSalesInvoices(queryOptions);
        }
    }
    componentWillUnmount() {
        this.props.cleanSalesInvoices();
        this.props.cleanYears();
    }

    updateQueryOptions = (selectedYear) => {
        queryOptions.filters = {
            document_date: {
                $gte: new Date(moment(selectedYear, "YYYY").startOf("year")),
                $lt: new Date(moment(selectedYear, "YYYY").endOf("year"))
            },
            type: { $in: ["standard", "corrected"] }
        };
    };

    onChangeYear = (year) => {
        this.setState({
            selectedYear: year
        });

        Auth.setSelectedYear(year);
    };

    render() {
        const yearOptions = this.props.years || List([Map({ year: moment().year })]);

        let tableData = this.props.salesInvoices;

        const salesInvoicesIsFetching = this.props.salesInvoicesIsFetching;

        // Filters Zone
        let totalInvoices = 0, totalUnpaid = 0;
        this.props.salesInvoices.forEach(invoice => {
            if (invoice.get('status') === 'unpaid') {
                totalUnpaid = totalUnpaid + invoice.getIn(['statistics', 'total']);
            }
            totalInvoices = totalInvoices + invoice.getIn(['statistics', 'total']);
        });
        let statsZone = (
            <div className="row stats-zone" style={{ marginBottom: 20 }} >
                <div className="col-auto">
                    <span className="label">{ numeral(totalInvoices).format() }</span>
                    <span>Total facturado</span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ numeral(totalUnpaid).format() }</span>
                    <span>Total pendiente de cobro</span>
                </div>
                <div className="col-auto">
                    <span className="label "><strong>{ this.props.salesInvoices.size || 0 }</strong></span>
                    <span className="handPointer" onClick={ () => this.setState({ salesInvoiceFilters: '' }) }><strong>Facturas</strong></span>
                </div>
                <div className="col-auto">
                    <span className="label label-primary">{ this.props.salesInvoices.count(order => order.get('status') === 'charged') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ salesInvoiceFilters: 'charged' }) }>Cobradas</span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ this.props.salesInvoices.count(order => order.get('status') === 'unpaid') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ salesInvoiceFilters: 'unpaid' }) }>Pendientes</span>
                </div>
            </div>
        );
        switch (this.state.salesInvoiceFilters) {
            case 'charged':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label">{ numeral(totalInvoices).format() }</span>
                            <span>Total facturado</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ numeral(totalUnpaid).format() }</span>
                            <span>Total pendiente de cobro</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ this.props.salesInvoices.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ salesInvoiceFilters: '' }) }>Facturas</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary"><strong>{ this.props.salesInvoices.count(order => order.get('status') === 'charged') }</strong></span>
                            <span className="handPointer" onClick={ () => this.setState({ salesInvoiceFilters: 'charged' }) }><strong>Cobradas</strong></span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ this.props.salesInvoices.count(order => order.get('status') === 'unpaid') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ salesInvoiceFilters: 'unpaid' }) }>Pendientes</span>
                        </div>
                    </div>
                );
                tableData = this.props.salesInvoices.filter(salesInvoice => salesInvoice.get('status') === 'charged');
                break;
            case 'unpaid':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label">{ numeral(totalInvoices).format() }</span>
                            <span>Total facturado</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ numeral(totalUnpaid).format() }</span>
                            <span>Total pendiente de cobro</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ this.props.salesInvoices.size || 0 }</span>
                            <span className="handPointer" onClick={ () => this.setState({ salesInvoiceFilters: '' }) }>Facturas</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ this.props.salesInvoices.count(order => order.get('status') === 'charged') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ salesInvoiceFilters: 'charged' }) }>Cobradas</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger"><strong>{ this.props.salesInvoices.count(order => order.get('status') === 'unpaid') }</strong></span>
                            <span className="handPointer" onClick={ () => this.setState({ salesInvoiceFilters: 'unpaid' }) }><strong>Pendientes</strong></span>
                        </div>
                    </div>
                );
                tableData = this.props.salesInvoices.filter(salesInvoice => salesInvoice.get('status') === 'unpaid');
                break;
            default:
                break;
        }

        // SalesInvoices Table
        let tableSettings = {
            showFooter: true,
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            invoice_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'invoice_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/ventas/facturas/' + value[0] }>{ value[1] }</Link>
                }
            },
            document_date: {
                title: "Fecha",
                columnType: 'date',
                dataField: 'document_date',
                width: 100,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            expiration_date: {
                title: "Fecha de vencimiento",
                columnType: 'date',
                dataField: 'expiration_date',
                width: 150,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            customer: {
                title: "Cliente",
                columnType: 'text',
                dataField: 'customer',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
            },
            subtotal: {
                title: "Subtotal",
                columnType: 'number',
                dataField: 'statistics.subtotal',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            vat: {
                title: "IVA",
                columnType: 'number',
                dataField: 'statistics.vat',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            include_retention: {
                title: "Incluye retención",
                columnType: 'function',
                dataField: 'include_retention',
                width: 130,
                style: { textAlign: 'left' },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    return (
                        <div>
                            <span>{value ? "Sí" : "No"}</span>
                        </div>
                    )
                }
            },
            retention: {
                title: "Retención",
                columnType: 'function',
                dataField: 'statistics.retention',
                width: 150,
                style: { textAlign: 'right' },
                sortable: false,
                filterable: true,
                //footer: { type: 'operation', value: 'sum' },
                nodeContent: (value) => {
                    return (
                        <div>
                            <span>{value > 0 && "-"} {numeral(value).format()}</span>
                        </div>
                    )
                }
            },
            total: {
                title: "Total",
                columnType: 'number',
                dataField: 'statistics.total',
                width: 150,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            status: {
                title: "Estado",
                columnType: 'function',
                dataField: 'status',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (status) => {
                    let data = { badgeColor: '', value: '' };

                    switch (status) {
                        case 'charged':
                            data.badgeColor = 'primary';
                            data.value = 'Cobrado';
                            break;
                        case 'unpaid':
                            data.badgeColor = 'danger';
                            data.value = 'Pendiente';
                            break;
                        default:
                            break;
                    }

                    return (
                        <div>
                            <span className={'badge badge-' + data.badgeColor}>
                                {data.value}
                            </span>
                        </div>
                    );
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: ['_id', 'status'],
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    let popoverContent = (<Menu></Menu>);

                    switch (value[1]) {
                        case 'unpaid':
                            popoverContent = (
                                <Menu>
                                    <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/ventas/facturas/' + value[0])} />
                                    <MenuItem icon="swap" text="Cobrado" onClick={ () => this.props.changeSalesInvoiceStatus(value[0], 'charged', queryOptions) } />
                                </Menu>
                            );
                            break;
                        case 'charged':
                            popoverContent = (
                                <Menu>
                                    <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/ventas/facturas/' + value[0])} />
                                    <MenuItem icon="swap" text="Pendiente" onClick={ () => this.props.changeSalesInvoiceStatus(value[0], 'unpaid', queryOptions) } />
                                </Menu>
                            );
                            break;
                        default:
                            break;
                    }

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/ventas/resumen">Ventas</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Facturas</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button className="btn btn-primary" onClick={ () => this.props.history.push('/ventas/facturas/nuevo') } > <Icon icon="insert"/>Factura</button>
                        </div>
                        <div className="title-action">
                            <Select
                                style={{ width: 75, marginLeft: 20 }}
                                options={yearOptions.toJS()}
                                value={this.state.selectedYear}
                                labelKey='year'
                                valueKey='year'
                                matchProp='year'
                                multi={false}
                                searchable={true}
                                clearable={false}
                                onChange={(selectedValue) => { if (selectedValue) this.onChangeYear(selectedValue.year) }}
                            />
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    { statsZone }
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-content">
                                    {salesInvoicesIsFetching ? (
                                        <Loading show={salesInvoicesIsFetching} />
                                    ) : (
                                        <VirtualizedTable
                                            tableSettings={tableSettings}
                                            tableColumns={tableColumns}
                                            tableData={tableData}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const yearsReducer = state.years;
    const salesInvoicesReducer = state.salesInvoices;

    // Years
    let years = yearsReducer.get('payload') || List([]);

    if (!(years instanceof List)) {
        years = List([])
    }

    // SalesInvoices
    let salesInvoices = salesInvoicesReducer.get('payload') || List([]);
    const salesInvoicesIsFetching = salesInvoicesReducer.get('isFetching');

    if (!(salesInvoices instanceof List)) {
        salesInvoices = List([])
    }

    return {
        years,
        salesInvoices,
        salesInvoicesIsFetching
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getYears: () => dispatch(getYears()),
        getSalesInvoices: (query) => dispatch(getSalesInvoices(query)),
        changeSalesInvoiceStatus: (salesInvoiceId, status, options) => dispatch(changeSalesInvoiceStatus(salesInvoiceId, status, options)),
        cleanYears: () => dispatch(cleanYears()),
        cleanSalesInvoices: () => dispatch(cleanSalesInvoices())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesInvoicesPage);


// WEBPACK FOOTER //
// ./src/containers/sales/invoices/SalesInvoicesPage.js